var exports = {
  "kL": "SegmentedTabs.module__container___S0RXVW",
  "gj": "SegmentedTabs.module__tabList___S0RXVW",
  "Mf": "SegmentedTabs.module__tab___S0RXVW",
  "DF": "SegmentedTabs.module__tabInactive___S0RXVW",
  "yR": "SegmentedTabs.module__tabActive___S0RXVW",
  "KE": "SegmentedTabs.module__tabBackground___S0RXVW",
};

module.exports = exports;
